import { Component, OnInit } from '@angular/core';
import { RouterOutlet } from '@angular/router';

/**
 * This component is used primarily for routing. It displays other pages
 * within the PatientsModule based on the URL through the <router-outlet> tag.
 */
@Component({
    selector: 'app-patients-home-page',
    template: `<router-outlet></router-outlet>`,
    styles: [],
    standalone: true,
    imports: [RouterOutlet],
})
export class PatientsHomePageComponent implements OnInit {
  constructor() {}

  ngOnInit(): void {}
}
